import { formatDateTime, formatRelativeTime } from "@/lib/format";
import { cn } from "@/lib/utils";

/** "3h ago" with the exact date and time on hover; older than a week shows the date. */
export function RelativeTime({
  value,
  className,
  fallback = "Never",
}: {
  value: string | null | undefined;
  className?: string;
  fallback?: string;
}) {
  if (!value) return <span className={className}>{fallback}</span>;
  return (
    <time
      dateTime={value}
      title={formatDateTime(value)}
      className={cn("whitespace-nowrap", className)}
    >
      {formatRelativeTime(value)}
    </time>
  );
}
